import React from 'react';
import { Video, Tv, Film, FileText, Briefcase, Smartphone, Calendar, PartyPopper, Radio } from 'lucide-react';

const WhatWeProduce = () => {
  const categories = [
    { icon: Video, text: 'Podcasts & Talk Shows' },
    { icon: Tv, text: 'TV-Style Interviews' },
    { icon: Film, text: 'Short Films & TV Series' },
    { icon: FileText, text: 'Documentaries' },
    { icon: Briefcase, text: 'Corporate & Brand Content' },
    { icon: Smartphone, text: 'Social Media Promos / Reels' },
    { icon: Calendar, text: 'Live Events & Highlights' },
    { icon: PartyPopper, text: 'Carnival Coverage & Media' },
    { icon: Radio, text: 'Live Streaming' }
  ];

  return (
    <section className="relative z-10 py-24 sm:py-32 border-t border-white/[0.06]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-8">
          {/* Left — sticky heading */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-32">
              <p className="ltv-eyebrow text-red-500 mb-4">03 — Output</p>
              <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-white leading-[1.05] mb-6">
                What we
                <span className="text-gray-500"> produce.</span>
              </h2>
              <p className="text-gray-400 max-w-sm text-base leading-relaxed">
                Creator, brand or event organiser — we bring stories to life across every format.
              </p>
            </div>
          </div>

          {/* Right — editorial index */}
          <div className="lg:col-span-7">
            {categories.map((category, index) => {
              const Icon = category.icon;
              return (
                <div
                  key={index}
                  className="group flex items-center gap-5 sm:gap-7 border-t border-white/[0.08] last:border-b py-5 sm:py-6 hover:bg-white/[0.02] transition-colors"
                >
                  <span className="font-display text-xs font-semibold text-gray-600 group-hover:text-red-500 transition-colors w-6 shrink-0">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <p className="font-display text-xl sm:text-2xl font-bold text-white group-hover:translate-x-2 transition-transform duration-300">
                    {category.text}
                  </p>
                  <Icon className="h-5 w-5 text-gray-700 group-hover:text-red-500 ml-auto shrink-0 transition-colors" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeProduce;
